<template>
	<router-view v-if="isLoaded"></router-view>
	<div v-else>Procesando...</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import router from "@/router/index.js";

export default {
	name: "app",
	computed: {
		...mapGetters(["isLogged"]),
	},
	data: () => {
		return {
			isLoaded: false
		}
	},
	methods: {
		...mapActions(["recoverFromDixie"]),
		async checkIsLogged() {
			if (!this.isLogged) {
				let isLogged = await this.recoverFromDixie()
				if (!isLogged) {
					router.push({
						name: "Auth",
					});
				}
			}
		},
	},
	watch: {
		$route(to, from) {
			this.checkIsLogged();
		},
	},
	beforeCreate() {
		function forceSSL() {
			// REVIEW OF FORCED SSL DNS, THIS CASE RELOCATES ONLY IN [foots.com.mx]
			let regexDOMAN = /\/\/refapp\.online/,
				regEX = /^http\:/;
			if ( regexDOMAN.test(window.document.documentURI) && regEX.test(window.document.documentURI) ) {
				window.document.location = window.document.documentURI.replace( regEX, "https:" );
			}
		}
		forceSSL();
	},
	async beforeMount() {
		this.isLoaded = false
		await this.checkIsLogged();
		this.isLoaded = true
	},
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
// @import '~flag-icon-css/css/flag-icon.min.css';
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
@import "~@mobiscroll/javascript/dist/css/mobiscroll.scss";
</style>
